import { render, staticRenderFns } from "./CardsCaroussel.vue?vue&type=template&id=7d7852d2&scoped=true"
import script from "./CardsCaroussel.vue?vue&type=script&lang=js"
export * from "./CardsCaroussel.vue?vue&type=script&lang=js"
import style0 from "./CardsCaroussel.vue?vue&type=style&index=0&id=7d7852d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7852d2",
  null
  
)

export default component.exports